import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  sidebarShell: {
    height: "100%",
    position: "relative",
    overflow: "visible",
    background: "linear-gradient(180deg, #004a36 0%, #004131 48%, #003b31 100%)",
    borderRight: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "16px 0 34px rgba(4, 47, 43, 0.24)",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: 310,
      background: "url('/assets/images/sidebar_reference_art.png') bottom center / 100% auto no-repeat",
      opacity: 0.88,
      pointerEvents: "none",
      zIndex: 0,
      WebkitMaskImage: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.28) 18%, #000 38%, #000 100%)",
      maskImage: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.28) 18%, #000 38%, #000 100%)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: "linear-gradient(180deg, rgba(0,74,54,0) 0%, rgba(0,74,54,0) 58%, rgba(0,74,54,0.22) 74%, rgba(0,45,39,0.2) 100%)",
      pointerEvents: "none",
      zIndex: 1,
    },
  },
  root: {
    height: "calc(100% - 108px)",
    left: 0,
    position: "relative",
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: 0,
    background: "transparent",
    scrollbarWidth: "none",
    "& .MuiSvgIcon-root": {
      color: "currentColor",
      fontSize: 22,
      opacity: 0.98,
    },
    "& .MuiList-root": {
      position: "relative",
      zIndex: 3,
      paddingTop: 0,
      paddingBottom: 0,
      marginBottom: 6,
    },
    "& .MuiListItemButton-root": {
      minHeight: 46,
      margin: "0 14px",
      padding: "10px 14px",
      borderRadius: 11,
      color: "rgba(255,255,255,0.9)",
      transition: "all 160ms ease",
      "&:hover": {
        background: "rgba(8, 153, 101, 0.28)",
        color: "#fff",
      },
      "&.Mui-selected": {
        minHeight: 61,
        background: "linear-gradient(90deg, rgba(10, 183, 125, 0.96), rgba(10, 136, 92, 0.94))",
        color: "#fff",
        boxShadow: "0 14px 30px rgba(0, 20, 17, 0.18)",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 15,
          bottom: 15,
          width: 3,
          borderRadius: 999,
          background: "#16f09f",
        },
        "&:hover": {
          background: "linear-gradient(90deg, rgba(10, 183, 125, 1), rgba(10, 136, 92, 0.98))",
        },
      },
    },
    "& .MuiListItemIcon-root": {
      minWidth: 38,
      color: "inherit",
      justifyContent: "center",
      "& img": {
        width: 18,
        height: 18,
        objectFit: "contain",
        filter: "brightness(0) invert(1)",
        opacity: 0.9,
      },
    },
  },
  sidebarmenu: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    scrollbarWidth: "none",
  },
  sidebarmenu2: {
    height: "100%",
    flexDirection: "column",
    display: "flex",
    overflowX: "hidden",
    scrollbarWidth: "none",
  },
  brandBar: {
    minHeight: 108,
    position: "relative",
    zIndex: 4,
    display: "flex",
    alignItems: "flex-start",
    padding: "20px 16px 12px",
    background: "transparent",
  },
  brandButton: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    padding: 0,
    border: 0,
    background: "transparent",
    cursor: "pointer",
    color: "#fff",
    textAlign: "left",
  },
  brandMark: {
    width: 45,
    height: 45,
    borderRadius: 10,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    background: "linear-gradient(145deg, #11a06e, #08754f)",
    boxShadow: "0 10px 24px rgba(0, 19, 15, 0.18)",
    overflow: "hidden",
    "& img": {
      width: 31,
      height: 31,
      objectFit: "contain",
      filter: "brightness(0) invert(1)",
    },
  },
  brandText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    lineHeight: 1,
    paddingTop: 5,
    "& strong": {
      color: "#fff",
      fontSize: 18,
      fontWeight: 500,
      letterSpacing: 0,
    },
    "& small": {
      marginTop: 7,
      color: "rgba(255,255,255,0.86)",
      fontSize: 13,
      fontWeight: 800,
      letterSpacing: 0,
    },
  },
  toggleButton: {
    position: "absolute",
    right: -18,
    top: 57,
    zIndex: 20,
    width: 36,
    height: 36,
    borderRadius: 999,
    border: "1px solid #dfe8ef",
    background: "#fff",
    color: "#00734f",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(22, 42, 31, 0.16)",
    "&:hover": {
      background: "#f7fbff",
    },
  },
  subitemsicon: {
    justifyContent: "center",
  },
  subitemscontent: {
    margin: "4px 5px",
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: "cover",
    cursor: "pointer",
  },
  menuLabels: {
    "& .MuiTypography-root": {
      color: "#fff",
      fontWeight: 500,
      fontSize: 14,
    },
  },
  menuLabels2: {
    "& .MuiTypography-root": {
      fontWeight: 500,
      color: "rgba(255,255,255,0.92)",
      fontSize: 14,
    },
  },
  subMenuLabel: {
    "& .MuiTypography-root": {
      color: "rgba(255,255,255,0.7)",
      paddingInlineStart: 12,
      fontSize: 12,
      fontWeight: 700,
    },
  },
  subitemscolor: {
    marginInline: 14,
    borderRadius: 10,
  },
}));

export default useStyles;
